import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Loading from "../../Assets/Images/loading/loading3.png";
import Edit from "../../Assets/Images/edit.svg";
import Save from "../../Assets/Images/save.svg";
import Delete from "../../Assets/Images/delete1.svg";
import axios from "axios";
import { Context } from "../../Context/Context";

function PermissionTable({
  branchList,
  loading,
  setChangeStatus,
  changeStatus,
}) {
  const { lang } = useContext(Context);
  const navigate = useNavigate();
  const env = process.env.REACT_APP_API;
  const token = JSON.parse(window.localStorage.getItem("token"));

  // 🔹 Track which row is being edited
  const [editingId, setEditingId] = useState(null);
  // 🔹 Track the temporary value being edited
  const [editedValue, setEditedValue] = useState("");

  const handleMoreClick = (evt) => {
    evt.preventDefault();
    const id = Number(evt.currentTarget.id);

    // If clicking the same row again, save changes
    if (editingId === id) {
      handleSave(id);
    } else {
      // Otherwise, enter edit mode for this row
      const item = branchList.find((item) => item.id === id);
      setEditedValue(item.param);
      setEditingId(id);
    }
  };

  const handleSave = (id) => {
    axios
      .put(
        `${env}cabinet/v2/permission-param/update`,
        {
          id: id,
          param: editedValue,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        setEditingId(null); // exit edit mode
        setEditedValue("");
        setChangeStatus(!changeStatus); // trigger data refresh
      })
      .catch((err) => console.error("Update failed:", err));
  };

  const clickedActive = (evt) => {
    axios
      .put(
        `${env}cabinet/v2/permission-param/change-status?id=${Number(
          evt.target.id
        )}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        setChangeStatus(!changeStatus);
      });
  };

  return (
    <table className="w-full">
      <thead>
        <tr className="text-slate-400">
          <th className="font-normal uppercase text-[13px] xl:text-[16px] text-center p-2.5">
            ID
          </th>
          <th className="font-normal uppercase text-[13px] xl:text-[16px] text-center p-2.5">
            {lang ? "Заголовок" : "Nomi"}
          </th>
          <th className="font-normal uppercase text-[13px] xl:text-[16px] text-center  p-2.5">
            {lang ? "Сообщения" : "Qiymati"}
          </th>
          <th className="font-normal uppercase text-[13px] xl:text-[16px] text-center p-2.5">
            {lang ? "Статус" : "Holati"}
          </th>
          <th className="font-normal uppercase text-[13px] xl:text-[16px] text-center p-2.5 px-1">
            {lang ? "Редактирование" : "Tahrirlash"}
          </th>
        </tr>
      </thead>

      {loading ? (
        <tbody>
          <tr>
            <td colSpan="5" className="text-center p-4">
              <img
                className="flex mx-auto items-start justify-center"
                src={Loading}
                width={60}
                height={60}
                alt="Loading Icon"
              />
            </td>
          </tr>
        </tbody>
      ) : (
        <tbody>
          {branchList.length > 0 &&
            branchList.map((item) => (
              <tr key={item.id} className="even:bg-[#FAFAFA] ">
                <td className="border-t border-slate-300 text-center text-[13px] xl:text-[15px] p-2.5">
                  {item.id}
                </td>
                <td className="border-t border-slate-300 text-center text-[13px] xl:text-[15px] p-2.5">
                  {item.name}
                </td>

                <td className="border-t border-slate-300 text-center text-[13px] xl:text-[15px] p-2.5 w-[50%]">
                  {editingId === item.id ? (
                    <div className="flex items-center justify-end gap-2 relative pb-1">
                      <textarea
                        type="text"
                        value={editedValue}
                        rows={5}
                        cols={5}
                        onChange={(e) => setEditedValue(e.target.value)}
                        className="border border-slate-300 rounded px-2 py-1 w-[60%] text-start focus:border-blue-500 outline-none absolute top-0 left-0"
                        autoFocus
                      />
                      <div className="flex justify-center gap-2 w-[40%] top-0 right-0">
                        <button
                          onClick={() => handleSave(item.id)}
                          className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600 transition"
                        >
                          <img
                            id={item.id}
                            src={Save}
                            width={20}
                            height={20}
                            alt="Save"
                          />
                        </button>
                        <button
                          onClick={() => setEditingId(null)}
                          className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition"
                        >
                          <img
                            id={item.id}
                            src={Delete}
                            width={20}
                            height={20}
                            alt="Delete"
                          />
                        </button>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="text"
                      value={item.param}
                      readOnly
                      onChange={(e) => setEditedValue(e.target.value)}
                      className="border border-transparent rounded px-2 py-1 w-full text-center outline-none cursor-default"
                      autoFocus
                    />
                  )}
                </td>

                <td className="border-t border-slate-300 text-center text-[15px] p-2.5">
                  <div
                    id={item.id}
                    onClick={clickedActive}
                    className="flex cursor-pointer justify-center items-center"
                  >
                    <ul
                      id={item.id}
                      className={`w-[38px] ml-1 relative h-[20px] cursor-pointer ${
                        item.status ? "bg-blue-500" : "bg-slate-300"
                      } rounded-[50px]`}
                    >
                      <li
                        id={item.id}
                        className={`absolute duration-200 ${
                          item.status ? "translate-x-4" : ""
                        } inset-0.5 w-[45%] rounded-[50%] bg-white`}
                      ></li>
                    </ul>
                  </div>
                </td>

                <td className="border-t border-slate-300 text-center text-[15px] relative">
                  <button
                    onClick={handleMoreClick}
                    id={item.id}
                    className={`absolute top-0 left-0 right-0 bottom-0 m-auto flex justify-center items-center rounded-[50%] w-[30px] h-[30px] ${
                      editingId === item.id ? "bg-green-500" : "bg-blue-500"
                    }`}
                    disabled={editingId !== item.id ? false : true}
                  >
                    <img
                      id={item.id}
                      src={Edit}
                      width={20}
                      height={20}
                      alt="Edit"
                    />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      )}
    </table>
  );
}

export default PermissionTable;
